import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import BlueButton from 'components/inputs/BlueButton'
import SpanSpinner from 'components/SpanSpinner'
import { ICartOrder, IOrderPrice } from 'order_components/IOrder'
import React from 'react'
import { Col } from 'react-bootstrap'

const PAYMENT_TYPE_CASH = 1
const PAYMENT_TYPE_SBER = 2

interface ICartInfoPhaseButtonsProps {
  cart: ICartOrder
  orderPrice: IOrderPrice
  noProducts: boolean
  isLoading: boolean
  onGoToPrevScreen: VoidFunction
  onRequestWithoutPayment: VoidFunction
  onRequestWithPayment: VoidFunction
}

const CartInfoPhaseButtons: React.FC<ICartInfoPhaseButtonsProps> = ({
  cart,
  orderPrice,
  noProducts,
  isLoading,
  onGoToPrevScreen,
  onRequestWithoutPayment,
  onRequestWithPayment,
}) => {
  return (
    <>
      <Col sm={12} md={6} xl={4} className='d-flex justify-content-center'>
        <BlueButton onClick={onGoToPrevScreen} disabled={isLoading} className='px-3'>
          <>
            {isLoading ? (
              <SpanSpinner size='small' />
            ) : (
              <FontAwesomeIcon icon={faArrowLeft} />
            )}
            {' Назад к списку'}
          </>
        </BlueButton>
      </Col>

      {cart.office.payment_types.find(
        (pay_type) => pay_type.payment_type_id === PAYMENT_TYPE_CASH
      ) && (
        <Col sm={12} md={6} xl={4} className='d-flex justify-content-center'>
          <BlueButton
            onClick={onRequestWithoutPayment}
            disabled={noProducts || isLoading}
            className='px-3'
          >
            <>
              {'Оформить без оплаты  '}
              {isLoading ? (
                <SpanSpinner size='small' />
              ) : (
                <FontAwesomeIcon icon={faArrowRight} />
              )}
            </>
          </BlueButton>
        </Col>
      )}
      {cart.office.payment_types.find(
        (pay_type) => pay_type.payment_type_id === PAYMENT_TYPE_SBER
      ) && (
        <Col sm={12} md={12} xl={4} className='d-flex justify-content-center'>
          <BlueButton
            onClick={onRequestWithPayment}
            disabled={noProducts || isLoading || orderPrice.total_price >= 50000}
            className='px-3'
          >
            <>
              {'Перейти к оплате  '}
              {isLoading ? (
                <SpanSpinner size='small' />
              ) : (
                <FontAwesomeIcon icon={faArrowRight} />
              )}
            </>
          </BlueButton>
        </Col>
      )}
    </>
  )
}
export default CartInfoPhaseButtons
